import Row from "react-bootstrap/Row";
import InfoItem from "./InfoItem";
import useAppSelector from "../hooks/useAppSelector";

const SelectedBusDetails = () => {
  const selectedBus = useAppSelector(
    (state) => state.busAttendances.selectedBus
  );

  if (!selectedBus) {
    return null;
  }

  return (
    <Row>
      <InfoItem title="Bus name" info={selectedBus.busName} />
    </Row>
  );
};

export default SelectedBusDetails;
